import React, { useState, useEffect, useContext } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "./MoviePosterSlider.scss";
import { img_2000, unavailable } from "../../config/config";

// import Swiper core and required modules
import SwiperCore, { Navigation } from "swiper";
import MoviesDesc from "./MoviesDesc";
import { Rings } from "react-loader-spinner";

import { MovieIndexContext } from "../../context/MovieIndexContext";

// install Swiper modules
SwiperCore.use([Navigation]);

const MoviePosterSlider = ({ content, movieId, loading }) => {
  const [swiper, setSwiper] = useState(null);
  // eslint-disable-next-line
  const { movieIndex, setMovieId, setMovieIndex } =
    useContext(MovieIndexContext);
  const slideTo = (index) => swiper.slideTo(index);
  useEffect(() => {
    if (swiper) {
      slideTo(movieIndex);
      // console.log("workingggggggggg");
    } // eslint-disable-next-line
  }, [movieIndex, swiper]);

  useEffect(() => {
    setMovieId(0);
    // console.log("hiiiiiiiiiiiiii");
  }, [swiper, setMovieId]);
  return (
    <>
      <Swiper
        navigation={true}
        className="mySwiper"
        onSlideChange={movieId}
        onSwiper={setSwiper}
      >
        {React.Children.toArray(
          content?.map((item) => {
            return (
              <SwiperSlide style={{ backgroundColor: "black" }}>
                <img
                  className="movies-poster"
                  src={
                    loading ? (
                      item.poster_path ? (
                        `${img_2000}/${item.poster_path}`
                      ) : (
                        unavailable
                      )
                    ) : (
                      <Rings color="#00BFFF" height={80} width={80} />
                    )
                  }
                  alt="Movies-poster"
                />

                <MoviesDesc
                  title={item.title || item.name}
                  genre={item.genres_name}
                />
              </SwiperSlide>
            );
          })
        )}
      </Swiper>
    </>
  );
};
export default MoviePosterSlider;
